import React from "react";

const ButtonToolbar = (props: any) => {
    return <div className="button-toolbar">{props.children}</div>;
}

export default ButtonToolbar;
